"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PhotoAnnotator;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
// Kolory pisaka - jaskrawe, dobrze widoczne na zdjęciach z budowy.
const COLORS = ["#ff3b30", "#ffcc00", "#34c759", "#0a84ff", "#ffffff", "#000000"];
/**
 * Nakładka do rysowania palcem po zdjęciu (strzałki/zaznaczenia). Po zapisie
 * "wypala" rysunek w obrazie (canvas -> JPEG) i oddaje nowy Blob. Rysunek jest
 * na stałe w zdjęciu - zgodnie z decyzją nie przechowujemy osobno oryginału.
 */
function PhotoAnnotator({ src, onSave, onClose, }) {
    const canvasRef = (0, react_1.useRef)(null);
    const imgRef = (0, react_1.useRef)(null);
    const strokesRef = (0, react_1.useRef)([]);
    const drawingRef = (0, react_1.useRef)(false);
    const [color, setColor] = (0, react_1.useState)(COLORS[0]);
    const [ready, setReady] = (0, react_1.useState)(false);
    const [, force] = (0, react_1.useState)(0); // przerysowanie przycisków (cofnij aktywny)
    // Wczytaj obraz do canvasu w natywnej rozdzielczości (jakość zapisu).
    (0, react_1.useEffect)(() => {
        const img = new Image();
        img.onload = () => {
            imgRef.current = img;
            const canvas = canvasRef.current;
            if (!canvas)
                return;
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            redraw();
            setReady(true);
        };
        img.src = src;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [src]);
    function redraw() {
        const canvas = canvasRef.current;
        const img = imgRef.current;
        if (!canvas || !img)
            return;
        const ctx = canvas.getContext("2d");
        if (!ctx)
            return;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        for (const stroke of strokesRef.current)
            drawStroke(ctx, stroke);
    }
    function drawStroke(ctx, stroke) {
        if (stroke.points.length < 1)
            return;
        ctx.strokeStyle = stroke.color;
        ctx.lineWidth = stroke.width;
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
        ctx.beginPath();
        ctx.moveTo(stroke.points[0].x, stroke.points[0].y);
        for (const p of stroke.points.slice(1))
            ctx.lineTo(p.x, p.y);
        ctx.stroke();
    }
    // Przelicz współrzędne wskaźnika (CSS px) na piksele canvasu (natywne).
    function toCanvasPoint(e) {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        return {
            x: ((e.clientX - rect.left) / rect.width) * canvas.width,
            y: ((e.clientY - rect.top) / rect.height) * canvas.height,
        };
    }
    function onPointerDown(e) {
        if (!ready)
            return;
        e.preventDefault();
        e.target.setPointerCapture?.(e.pointerId);
        drawingRef.current = true;
        // Grubość proporcjonalna do rozdzielczości, by kreska była widoczna na foto.
        const width = Math.max(4, (canvasRef.current.width / 150) | 0);
        strokesRef.current.push({ color, width, points: [toCanvasPoint(e)] });
    }
    function onPointerMove(e) {
        if (!drawingRef.current)
            return;
        e.preventDefault();
        const stroke = strokesRef.current[strokesRef.current.length - 1];
        const prev = stroke.points[stroke.points.length - 1];
        const next = toCanvasPoint(e);
        stroke.points.push(next);
        // Rysujemy TYLKO nowy odcinek na już narysowanym canvasie - bez przerysowania
        // pełnowymiarowego zdjęcia przy każdym ruchu (to powodowało lagi na telefonie
        // przy zdjęciach wielomegapikselowych). Pełny redraw() tylko przy undo/clear.
        const ctx = canvasRef.current?.getContext("2d");
        if (ctx && prev) {
            ctx.strokeStyle = stroke.color;
            ctx.lineWidth = stroke.width;
            ctx.lineCap = "round";
            ctx.lineJoin = "round";
            ctx.beginPath();
            ctx.moveTo(prev.x, prev.y);
            ctx.lineTo(next.x, next.y);
            ctx.stroke();
        }
    }
    function onPointerUp() {
        if (drawingRef.current) {
            drawingRef.current = false;
            force((n) => n + 1);
        }
    }
    function undo() {
        strokesRef.current.pop();
        redraw();
        force((n) => n + 1);
    }
    function clearAll() {
        strokesRef.current = [];
        redraw();
        force((n) => n + 1);
    }
    function save() {
        const canvas = canvasRef.current;
        if (!canvas)
            return;
        canvas.toBlob((blob) => {
            if (blob)
                onSave(blob);
        }, "image/jpeg", 0.85);
    }
    const hasStrokes = strokesRef.current.length > 0;
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: onClose, fullscreen: true },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, { className: "fs-6" }, "Zaznacz na zdj\u0119ciu")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: "d-flex flex-column align-items-center bg-dark p-2" },
            react_1.default.createElement("div", { className: "d-flex gap-2 mb-2 flex-wrap justify-content-center" },
                COLORS.map((c) => (react_1.default.createElement("button", { key: c, type: "button", onClick: () => setColor(c), "aria-label": `Kolor ${c}`, style: {
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        background: c,
                        border: color === c
                            ? "3px solid #fff"
                            : "2px solid rgba(255,255,255,0.4)",
                        boxShadow: color === c ? "0 0 0 2px #000" : "none",
                    } }))),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-light", size: "sm", onClick: undo, disabled: !hasStrokes, title: "Cofnij" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faRotateLeft })),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-light", size: "sm", onClick: clearAll, disabled: !hasStrokes, title: "Wyczy\u015B\u0107" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrashCan }))),
            react_1.default.createElement("canvas", { ref: canvasRef, onPointerDown: onPointerDown, onPointerMove: onPointerMove, onPointerUp: onPointerUp, onPointerLeave: onPointerUp, style: {
                    maxWidth: "100%",
                    maxHeight: "calc(100vh - 190px)",
                    touchAction: "none",
                    background: "#000",
                    borderRadius: 4,
                } })),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: onClose }, "Anuluj"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: save }, "Zapisz zaznaczenia"))));
}
